var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	51968: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	97518: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	42238: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-api_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/api */ 17780))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/api",
	},
	88830: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	2814: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	20700: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/ripple */ 30078))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/ripple",
	},
	40128: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	33632: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_fluid_primeng_fluid"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basemodelholder_primeng_basemodelholder"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-inputtext_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/inputtext */ 48361))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/inputtext",
	},
	59514: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	81344: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	35572: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-tooltip_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/tooltip */ 80405))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/tooltip",
	},
	87824: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_fluid_primeng_fluid"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_badge_primeng_badge"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-button_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/button */ 49136))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/button",
	},
	56360: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @uweb-one/config */ 34620))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/config",
	},
	92668: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",
	},
	86661: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__dom_renderer-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	98920: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-radiobutton_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/radiobutton */ 54665))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/radiobutton",
	},
	60786: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_config_uweb-one_config"), __webpack_require__.e("default-libs_core_api_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uweb-one/api */ 12356))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/api",
	},
	87748: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	2324: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/iconfield */ 92029))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/iconfield",
	},
	10664: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/inputicon */ 13167))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/inputicon",
	},
	30171: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs").then(() => (() => (__webpack_require__(/*! @ngrx/effects */ 70347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",
	},
	43534: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_api_primeng_api"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_inputtext_primeng_inputtext"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_button_primeng_button"), __webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_config_uweb-one_config"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_checkbox_primeng_checkbox"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_radiobutton_primeng_radiobutton"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_inputotp_primeng_inputotp"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_progressspinner_primeng_progressspinner"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_menu_primeng_menu"), __webpack_require__.e("default-libs_shared_ui_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uweb-one/ui */ 51874))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/ui",
	},
	64204: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_motion_primeng_motion"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_badge_primeng_badge"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_tooltip_primeng_tooltip"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-menu_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/menu */ 23673))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/menu",
	},
	53352: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_api_primeng_api"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_primeuix_styled_dist_index_mjs"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-config_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/config */ 62746))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/config",
	},
	42980: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_auth_uweb-one_auth"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_models_uweb-one_models"), __webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_api_uweb-one_api"), __webpack_require__.e("default-webpack_sharing_consume_default_ngrx_effects_ngrx_effects-webpack_sharing_consume_def-f87c75"), __webpack_require__.e("default-libs_core_store_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uweb-one/store */ 3897))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/store",
	},
	59320: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-selectbutton_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/selectbutton */ 69656))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/selectbutton",
	},
	71796: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_motion_primeng_motion"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseinput_primeng_baseinput"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-datepicker_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/datepicker */ 29786))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/datepicker",
	},
	61792: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__dom_renderer-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations/async */ 39192))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations/async",
	},
	86447: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_store-devtools_fesm2022_ngrx-store-devtools_mjs").then(() => (() => (__webpack_require__(/*! @ngrx/store-devtools */ 11925))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store-devtools",
	},
	71594: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_router-store_fesm2022_ngrx-router-store_mjs").then(() => (() => (__webpack_require__(/*! @ngrx/router-store */ 32175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/router-store",
	},
	8689: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_styled_dist_index_mjs"), __webpack_require__.e("node_modules_primeuix_themes_dist_index_mjs")]).then(() => (() => (__webpack_require__(/*! @primeuix/themes */ 50968))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@primeuix/themes",
	},
	57736: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_motion_primeng_motion"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_focustrap_primeng_focustrap"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-drawer_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/drawer */ 98007))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/drawer",
	},
	18700: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-toggleswitch_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/toggleswitch */ 18344))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/toggleswitch",
	},
	40500: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_motion_primeng_motion"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-toast_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/toast */ 61225))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/toast",
	},
	79628: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @uweb-one/guards */ 6548))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/guards",
	},
	94384: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_auth_uweb-one_auth"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @uweb-one/interceptors */ 67322))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/interceptors",
	},
	6322: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",
	},
	78520: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",
	},
	87038: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @uweb-one/models */ 39258))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/models",
	},
	5840: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_config_uweb-one_config"), __webpack_require__.e("default-webpack_sharing_consume_default_uweb-one_models_uweb-one_models"), __webpack_require__.e("default-libs_core_auth_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uweb-one/auth */ 76004))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uweb-one/auth",
	},
	59920: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_check_primeng_icons_check-webpack_shari-359084"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-checkbox_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/checkbox */ 26771))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/checkbox",
	},
	69400: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-inputotp_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/inputotp */ 86507))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/inputotp",
	},
	4630: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/progressspinner */ 53244))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/progressspinner",
	},
	53340: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseinput_primeng_baseinput"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_scroller_primeng_scroller"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_overlay_primeng_overlay"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-autocomplete_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/autocomplete */ 38784))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/autocomplete",
	},
	61176: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_badge_primeng_badge"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_tooltip_primeng_tooltip"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-megamenu_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/megamenu */ 20279))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/megamenu",
	},
	34868: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_motion_primeng_motion"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_focustrap_primeng_focustrap"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-dialog_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/dialog */ 16280))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/dialog",
	},
	98344: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_styled_dist_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_usestyle_primeng_usestyle"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/base */ 82451))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/base",
	},
	54246: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_styled_dist_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_config_primeng_config"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-basecomponent_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/basecomponent */ 1504))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/basecomponent",
	},
	46432: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_primeuix_utils_dist_classnames_index_mjs-_53022")]).then(() => (() => (__webpack_require__(/*! primeng/bind */ 55693))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/bind",
	},
	48974: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_arrowdown_primeng_icons_arrowdown-webpa-e08a89"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_check_primeng_icons_check-webpack_shari-359084"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons */ 72210))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons",
	},
	25464: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/autofocus */ 17159))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/autofocus",
	},
	39584: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_fluid_primeng_fluid"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/baseinput */ 31921))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/baseinput",
	},
	48760: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-scroller_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/scroller */ 22222))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/scroller",
	},
	79946: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_motion_primeng_motion"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-overlay_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/overlay */ 33576))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/overlay",
	},
	59876: {
		fallback: () => (__webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-chip_mjs").then(() => (() => (__webpack_require__(/*! primeng/chip */ 35678))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/chip",
	},
	40998: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-autocomplete_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/autocomplete */ 98872))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/autocomplete",
	},
	43062: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_styled_dist_index_mjs"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-dom_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/dom */ 35228))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/dom",
	},
	48672: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/usestyle */ 48692))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/usestyle",
	},
	3510: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/basemodelholder */ 79728))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/basemodelholder",
	},
	21820: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_basemodelholder_primeng_basemodelholder"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/baseeditableholder */ 75069))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/baseeditableholder",
	},
	40034: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_types_fluid_primeng_types_fluid"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/fluid */ 73432))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/fluid",
	},
	99620: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-badge_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/badge */ 72773))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/badge",
	},
	40162: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-button_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/button */ 32456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/button",
	},
	2214: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-check_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/check */ 82289))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/check",
	},
	24202: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-minus_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/minus */ 77965))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/minus",
	},
	79145: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-checkbox_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/checkbox */ 1195))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/checkbox",
	},
	44466: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-chip_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/chip */ 56214))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/chip",
	},
	98480: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-utils_mjs").then(() => (() => (__webpack_require__(/*! primeng/utils */ 7251))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/utils",
	},
	39628: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-motion_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/motion */ 42878))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/motion",
	},
	80514: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-datepicker_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/datepicker */ 94610))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/datepicker",
	},
	37512: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! primeng/focustrap */ 61257))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/focustrap",
	},
	59950: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-dialog_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/dialog */ 74080))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/dialog",
	},
	33406: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-drawer_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/drawer */ 53391))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/drawer",
	},
	99236: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-fluid_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/fluid */ 82848))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/fluid",
	},
	38070: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_primeuix_utils_dist_classnames_index_mjs-_53023")]).then(() => (() => (__webpack_require__(/*! primeng/icons/baseicon */ 98879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/baseicon",
	},
	37664: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-arrowdown_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowdown */ 25306))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/arrowdown",
	},
	20650: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-arrowup_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowup */ 25809))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/arrowup",
	},
	40670: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-filter_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/filter */ 53529))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/filter",
	},
	63180: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-filterslash_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/filterslash */ 12032))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/filterslash",
	},
	12998: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-plus_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/plus */ 41155))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/plus",
	},
	71476: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-sortalt_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/sortalt */ 63868))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/sortalt",
	},
	75742: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-sortamountdown_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/sortamountdown */ 19407))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/sortamountdown",
	},
	68222: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-sortamountupalt_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/sortamountupalt */ 71293))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/sortamountupalt",
	},
	24051: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-spinner_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/spinner */ 4766))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/spinner",
	},
	93350: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-trash_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/trash */ 24299))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/trash",
	},
	1990: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angledoubledown_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubledown */ 59983))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angledoubledown",
	},
	58384: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angledoubleleft_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubleleft */ 78540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angledoubleleft",
	},
	67326: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angledoubleright_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubleright */ 14607))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angledoubleright",
	},
	51504: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angledoubleup_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledoubleup */ 78712))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angledoubleup",
	},
	95936: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angledown_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angledown */ 98776))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angledown",
	},
	9350: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angleleft_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angleleft */ 10203))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angleleft",
	},
	99406: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angleright_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angleright */ 61726))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angleright",
	},
	79350: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-angleup_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/angleup */ 31147))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/angleup",
	},
	81690: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-arrowdownleft_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowdownleft */ 22801))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/arrowdownleft",
	},
	54182: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-arrowdownright_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowdownright */ 47972))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/arrowdownright",
	},
	25918: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-arrowleft_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowleft */ 74669))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/arrowleft",
	},
	81582: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-arrowright_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/arrowright */ 90248))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/arrowright",
	},
	76836: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-ban_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/ban */ 32774))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/ban",
	},
	23330: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-bars_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/bars */ 15961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/bars",
	},
	93974: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-blank_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/blank */ 97243))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/blank",
	},
	41618: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-calendar_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/calendar */ 24837))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/calendar",
	},
	56326: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-caretleft_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/caretleft */ 56987))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/caretleft",
	},
	5642: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-caretright_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/caretright */ 72798))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/caretright",
	},
	82440: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-chevrondown_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevrondown */ 85804))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/chevrondown",
	},
	42998: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-chevronleft_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevronleft */ 44959))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/chevronleft",
	},
	27794: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-chevronright_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevronright */ 45994))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/chevronright",
	},
	15830: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-chevronup_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/chevronup */ 37223))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/chevronup",
	},
	47252: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-exclamationtriangle_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/exclamationtriangle */ 13814))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/exclamationtriangle",
	},
	70604: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-eye_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/eye */ 40210))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/eye",
	},
	17766: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-eyeslash_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/eyeslash */ 23217))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/eyeslash",
	},
	2166: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-home_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/home */ 61582))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/home",
	},
	24534: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-infocircle_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/infocircle */ 48075))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/infocircle",
	},
	30658: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-pencil_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/pencil */ 95056))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/pencil",
	},
	34948: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-refresh_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/refresh */ 30924))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/refresh",
	},
	47958: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-search_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/search */ 73647))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/search",
	},
	64598: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-searchminus_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/searchminus */ 83589))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/searchminus",
	},
	65990: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-searchplus_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/searchplus */ 44715))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/searchplus",
	},
	45878: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-star_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/star */ 13547))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/star",
	},
	35278: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-starfill_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/starfill */ 24172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/starfill",
	},
	44600: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-thlarge_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/thlarge */ 60576))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/thlarge",
	},
	78342: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-times_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/times */ 57727))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/times",
	},
	75382: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-timescircle_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/timescircle */ 20839))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/timescircle",
	},
	91654: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-undo_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/undo */ 88041))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/undo",
	},
	24030: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-upload_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/upload */ 65596))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/upload",
	},
	30698: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-windowmaximize_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/windowmaximize */ 31717))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/windowmaximize",
	},
	79998: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("node_modules_primeng_fesm2022_primeng-icons-windowminimize_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/icons/windowminimize */ 69551))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/windowminimize",
	},
	42086: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-inputnumber_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/inputnumber */ 25319))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/inputnumber",
	},
	79833: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-megamenu_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/megamenu */ 11551))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/megamenu",
	},
	60638: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-menu_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/menu */ 19217))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/menu",
	},
	19976: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_object_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_inputtext_primeng_inputtext"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseinput_primeng_baseinput"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_tooltip_primeng_tooltip"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_scroller_primeng_scroller"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_overlay_primeng_overlay"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_iconfield_primeng_iconfield-webpack_sharing_c-5d982b"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-select_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/select */ 38608))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/select",
	},
	62200: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_inputtext_primeng_inputtext"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseinput_primeng_baseinput"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-inputnumber_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/inputnumber */ 61759))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/inputnumber",
	},
	20222: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-paginator_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/paginator */ 49101))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/paginator",
	},
	60166: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-password_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/password */ 56571))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/password",
	},
	7266: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-radiobutton_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/radiobutton */ 87761))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/radiobutton",
	},
	70526: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-scroller_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/scroller */ 75158))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/scroller",
	},
	92578: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-select_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/select */ 51672))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/select",
	},
	33954: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-selectbutton_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/selectbutton */ 99200))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/selectbutton",
	},
	54268: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-togglebutton_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/togglebutton */ 95656))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/togglebutton",
	},
	46548: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-table_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/table */ 52988))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/table",
	},
	59694: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! primeng/icons/filterfill */ 21790))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/icons/filterfill",
	},
	33244: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-paginator_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/paginator */ 43157))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/paginator",
	},
	88684: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-tag_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/tag */ 38904))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/tag",
	},
	56998: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-toast_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/toast */ 69473))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/toast",
	},
	96526: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-togglebutton_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/togglebutton */ 80864))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/togglebutton",
	},
	81502: {
		fallback: () => (__webpack_require__.e("node_modules_primeng_fesm2022_primeng-types-toggleswitch_mjs").then(() => (() => (__webpack_require__(/*! primeng/types/toggleswitch */ 27744))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/types/toggleswitch",
	},
	77544: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_primeng_icons"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_baseinput_primeng_baseinput"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_fluid_primeng_fluid"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_overlay_primeng_overlay"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-password_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/password */ 96371))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/password",
	},
	95090: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-tag_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/tag */ 93616))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/tag",
	},
	17490: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_primeng_base_primeng_base"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_bind_primeng_bind"), __webpack_require__.e("default-node_modules_primeuix_utils_dist_dom_index_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_dom_primeng_dom"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_utils_primeng_utils"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_motion_primeng_motion"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_badge_primeng_badge"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_scroller_primeng_scroller"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_checkbox_primeng_checkbox"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_select_primeng_select"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_icons_arrowdown_primeng_icons_arrowdown-webpa-e08a89"), __webpack_require__.e("default-webpack_sharing_consume_default_primeng_inputnumber_primeng_inputnumber"), __webpack_require__.e("default-node_modules_primeng_fesm2022_primeng-table_mjs")]).then(() => (() => (__webpack_require__(/*! primeng/table */ 76676))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.1.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "primeng/table",
	},
	15966: {
		fallback: () => (__webpack_require__.e("webpack_container_remote_admin_Routes").then(() => (() => (__webpack_require__(/*! admin/Routes */ 51069))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "admin/Routes",
	},
	32120: {
		fallback: () => (__webpack_require__.e("webpack_container_remote_lms_Routes").then(() => (() => (__webpack_require__(/*! lms/Routes */ 86310))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lms/Routes",
	},
	82680: {
		fallback: () => (__webpack_require__.e("webpack_container_remote_serving_Routes").then(() => (() => (__webpack_require__(/*! serving/Routes */ 57490))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "serving/Routes",
	},
	9834: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_animations_fesm2022_browser_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		51968
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		97518
	],
	"default-webpack_sharing_consume_default_primeng_api_primeng_api": [
		42238
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		88830
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		2814
	],
	"default-webpack_sharing_consume_default_primeng_ripple_primeng_ripple": [
		20700
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		40128
	],
	"default-webpack_sharing_consume_default_primeng_inputtext_primeng_inputtext": [
		33632
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		59514
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		81344
	],
	"default-webpack_sharing_consume_default_primeng_tooltip_primeng_tooltip": [
		35572
	],
	"default-webpack_sharing_consume_default_primeng_button_primeng_button": [
		87824
	],
	"default-webpack_sharing_consume_default_uweb-one_config_uweb-one_config": [
		56360
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store": [
		92668
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		86661
	],
	"default-webpack_sharing_consume_default_primeng_radiobutton_primeng_radiobutton": [
		98920
	],
	"default-webpack_sharing_consume_default_uweb-one_api_uweb-one_api": [
		60786
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		87748
	],
	"default-webpack_sharing_consume_default_primeng_iconfield_primeng_iconfield-webpack_sharing_c-5d982b": [
		2324,
		10664
	],
	"default-webpack_sharing_consume_default_ngrx_effects_ngrx_effects-webpack_sharing_consume_def-f87c75": [
		30171,
		43534
	],
	"default-webpack_sharing_consume_default_primeng_menu_primeng_menu": [
		64204
	],
	"default-webpack_sharing_consume_default_primeng_config_primeng_config": [
		53352
	],
	"default-webpack_sharing_consume_default_uweb-one_store_uweb-one_store": [
		42980
	],
	"default-webpack_sharing_consume_default_primeng_datepicker_primeng_datepicker-webpack_sharing-22454c": [
		59320,
		71796
	],
	"apps_shell_src_bootstrap_ts": [
		61792,
		86447,
		71594,
		8689,
		57736,
		18700,
		40500,
		79628,
		94384
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		6322,
		78520
	],
	"default-webpack_sharing_consume_default_uweb-one_models_uweb-one_models": [
		87038
	],
	"default-webpack_sharing_consume_default_uweb-one_auth_uweb-one_auth": [
		5840
	],
	"default-webpack_sharing_consume_default_primeng_checkbox_primeng_checkbox": [
		59920
	],
	"default-webpack_sharing_consume_default_primeng_inputotp_primeng_inputotp": [
		69400
	],
	"default-webpack_sharing_consume_default_primeng_progressspinner_primeng_progressspinner": [
		4630
	],
	"default-libs_shared_ui_src_index_ts": [
		53340,
		61176,
		34868
	],
	"default-webpack_sharing_consume_default_primeng_base_primeng_base": [
		98344
	],
	"default-webpack_sharing_consume_default_primeng_basecomponent_primeng_basecomponent": [
		54246
	],
	"default-webpack_sharing_consume_default_primeng_bind_primeng_bind": [
		46432
	],
	"default-webpack_sharing_consume_default_primeng_icons_primeng_icons": [
		48974
	],
	"default-webpack_sharing_consume_default_primeng_autofocus_primeng_autofocus": [
		25464
	],
	"default-webpack_sharing_consume_default_primeng_baseinput_primeng_baseinput": [
		39584
	],
	"default-webpack_sharing_consume_default_primeng_scroller_primeng_scroller": [
		48760
	],
	"default-webpack_sharing_consume_default_primeng_overlay_primeng_overlay": [
		79946
	],
	"default-node_modules_primeng_fesm2022_primeng-autocomplete_mjs": [
		59876,
		40998
	],
	"default-webpack_sharing_consume_default_primeng_dom_primeng_dom": [
		43062
	],
	"default-webpack_sharing_consume_default_primeng_usestyle_primeng_usestyle": [
		48672
	],
	"default-webpack_sharing_consume_default_primeng_basemodelholder_primeng_basemodelholder": [
		3510
	],
	"default-webpack_sharing_consume_default_primeng_baseeditableholder_primeng_baseeditableholder": [
		21820
	],
	"default-webpack_sharing_consume_default_primeng_fluid_primeng_fluid": [
		40034
	],
	"default-webpack_sharing_consume_default_primeng_badge_primeng_badge": [
		99620
	],
	"default-node_modules_primeng_fesm2022_primeng-button_mjs": [
		40162
	],
	"default-webpack_sharing_consume_default_primeng_icons_check_primeng_icons_check-webpack_shari-359084": [
		2214,
		24202
	],
	"default-node_modules_primeng_fesm2022_primeng-checkbox_mjs": [
		79145
	],
	"default-node_modules_primeng_fesm2022_primeng-chip_mjs": [
		44466
	],
	"default-webpack_sharing_consume_default_primeng_utils_primeng_utils": [
		98480
	],
	"default-webpack_sharing_consume_default_primeng_motion_primeng_motion": [
		39628
	],
	"default-node_modules_primeng_fesm2022_primeng-datepicker_mjs": [
		80514
	],
	"default-webpack_sharing_consume_default_primeng_focustrap_primeng_focustrap": [
		37512
	],
	"default-node_modules_primeng_fesm2022_primeng-dialog_mjs": [
		59950
	],
	"default-node_modules_primeng_fesm2022_primeng-drawer_mjs": [
		33406
	],
	"default-webpack_sharing_consume_default_primeng_types_fluid_primeng_types_fluid": [
		99236
	],
	"default-webpack_sharing_consume_default_primeng_icons_baseicon_primeng_icons_baseicon": [
		38070
	],
	"default-webpack_sharing_consume_default_primeng_icons_arrowdown_primeng_icons_arrowdown-webpa-e08a89": [
		37664,
		20650,
		40670,
		63180,
		12998,
		71476,
		75742,
		68222,
		24051,
		93350
	],
	"node_modules_primeng_fesm2022_primeng-icons_mjs": [
		1990,
		58384,
		67326,
		51504,
		95936,
		9350,
		99406,
		79350,
		81690,
		54182,
		25918,
		81582,
		76836,
		23330,
		93974,
		41618,
		56326,
		5642,
		82440,
		42998,
		27794,
		15830,
		47252,
		70604,
		17766,
		2166,
		24534,
		30658,
		34948,
		47958,
		64598,
		65990,
		45878,
		35278,
		44600,
		78342,
		75382,
		91654,
		24030,
		30698,
		79998
	],
	"default-node_modules_primeng_fesm2022_primeng-inputnumber_mjs": [
		42086
	],
	"default-node_modules_primeng_fesm2022_primeng-megamenu_mjs": [
		79833
	],
	"default-node_modules_primeng_fesm2022_primeng-menu_mjs": [
		60638
	],
	"default-webpack_sharing_consume_default_primeng_select_primeng_select": [
		19976
	],
	"default-webpack_sharing_consume_default_primeng_inputnumber_primeng_inputnumber": [
		62200
	],
	"default-node_modules_primeng_fesm2022_primeng-paginator_mjs": [
		20222
	],
	"default-node_modules_primeng_fesm2022_primeng-password_mjs": [
		60166
	],
	"default-node_modules_primeng_fesm2022_primeng-radiobutton_mjs": [
		7266
	],
	"default-node_modules_primeng_fesm2022_primeng-scroller_mjs": [
		70526
	],
	"default-node_modules_primeng_fesm2022_primeng-select_mjs": [
		92578
	],
	"default-node_modules_primeng_fesm2022_primeng-selectbutton_mjs": [
		33954,
		54268
	],
	"default-node_modules_primeng_fesm2022_primeng-table_mjs": [
		46548,
		59694,
		33244
	],
	"default-node_modules_primeng_fesm2022_primeng-tag_mjs": [
		88684
	],
	"default-node_modules_primeng_fesm2022_primeng-toast_mjs": [
		56998
	],
	"default-node_modules_primeng_fesm2022_primeng-togglebutton_mjs": [
		96526
	],
	"default-node_modules_primeng_fesm2022_primeng-toggleswitch_mjs": [
		81502
	],
	"default-apps_shell_src_app_pages_service_country_service_ts-webpack_sharing_consume_default_p-76c8bd": [
		77544
	],
	"apps_shell_src_app_pages_account_security_security_ts": [
		95090,
		17490
	],
	"webpack_sharing_consume_default_admin_Routes_admin_Routes": [
		15966
	],
	"webpack_sharing_consume_default_lms_Routes_lms_Routes": [
		32120
	],
	"webpack_sharing_consume_default_serving_Routes_serving_Routes": [
		82680
	],
	"webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		9834
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}